import axios from '@/libs/http'

/**
 * 获取管理员店员信息申请列表
 * */
export const getClerkCategoryCheckListForAdmin = (status, pageNo, pageSize) => {
    return axios.request({
        url: '/s/a/clerkCategoryExamineCheck/list',
        params: {
            status,
            pageNo,
            pageSize
        },
        method: 'get'
    })
}

/**
 * 获取会长店员信息申请列表
 * */
export const getClerkCategoryCheckListForGuilder = (status, pageNo, pageSize) => {
    return axios.request({
        url: '/s/g/clerkCategoryExamineCheck/list',
        params: {
            status,
            pageNo,
            pageSize
        },
        method: 'get'
    })
}

/**
 * 获取组长店员信息申请列表
 * */
export const getClerkCategoryCheckListForLeader = (status, pageNo, pageSize) => {
    return axios.request({
        url: '/s/l/clerkCategoryExamineCheck/list',
        params: {
            status,
            pageNo,
            pageSize
        },
        method: 'get'
    })
}

/**
 * 获取店员信息申请详情
 * */
export const getClerkCategoryCheckDetail = (id, clerkId) => {
    let data = new URLSearchParams()
    data.append("id", id)
    data.append("clerkId", clerkId)
    return axios.request({
        url: '/s/clerkCategoryExamineCheck/detail',
        data,
        method: 'post'
    })
}

/**
 * 审核店员分类审核信息
 */
export const checkClerkCategoryExamineApply = (id, status, reason) => {
    let data = new URLSearchParams()
    data.append("id", id)
    data.append("status", status)
    data.append("reason", reason == null ? '' : reason)
    return axios.request({
        url: '/s/clerkCategoryExamineCheck/checkApply',
        data,
        method: 'post'
    })
}
